import angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { BdxLocaleService, BdxLocaleManagementService } from '@buildium/ngx-app-utility/dist';
import { PollingService } from '@root/src/app/services/polling.service';

export const DowngradedCoreServicesModule = angular.module('buildium.manager.downgradedCoreServices', [])
    .factory('downgradedBdxLocaleService', downgradeInjectable(BdxLocaleService))
    .factory('downgradedBdxLocaleManagementService', downgradeInjectable(BdxLocaleManagementService))
    .factory('downgradedPollingService', downgradeInjectable(PollingService));
